{
  "v8d.workflow.approbation.one-person": "Approval by one person",
  "v8d.workflow.approbation.quorum": "Quorum approval",
  "v8d.workflow.approbation.sod": "Approval with separation of duties: a third party approves",
  "v8d.workflow.code.DROIT_NON_TENU": "You do not hold the right to view the organisation's templates.",
  "v8d.workflow.code.RESOURCE_UNAVAILABLE": "Workflow not found in your organisation.",
  "v8d.workflow.code.SANS_SESSION": "Your session has expired: please sign in again.",
  "v8d.workflow.declencheur.manual": "Triggered on demand",
  "v8d.workflow.declencheur.on_push": "Triggered on every push to the repository",
  "v8d.workflow.etat.chargement": "Loading: {{quoi}}…",
  "v8d.workflow.etat.erreur": "Could not read {{quoi}}.",
  "v8d.workflow.etat.introuvable": "Workflow not found in your organisation.",
  "v8d.workflow.etat.reessayer": "Retry",
  "v8d.workflow.etat.refus": "Access denied: {{quoi}}.",
  "v8d.workflow.etat_objet.brouillon": "Draft",
  "v8d.workflow.etat_objet.publie": "Published",
  "v8d.workflow.fiche.execution": "Run by the platform executor (no process engine).",
  "v8d.workflow.fiche.libelle": "the workflow record",
  "v8d.workflow.fiche.reference": "Reference declaration: {{porteur}}.",
  "v8d.workflow.fiche.reference_courante": "{{modele}}, current configuration",
  "v8d.workflow.fiche.reference_version": "{{modele}}, version {{n}}",
  "v8d.workflow.fiche.titre": "Workflow — record",
  "v8d.workflow.fiche.variantes": "Variants known in the organisation: {{n}}. A project runs the one of the template it is pinned to.",
  "v8d.workflow.graphe.declencheur": "{{declencheur}}.",
  "v8d.workflow.graphe.etapes": "Workflow steps",
  "v8d.workflow.graphe.minuteries": "No timers: the platform executor does not handle them.",
  "v8d.workflow.graphe.reprises": "Retries on error: {{reprises}}.",
  "v8d.workflow.graphe.reprises_par_defaut": "(platform defaults)",
  "v8d.workflow.graphe.titre": "Flow in words",
  "v8d.workflow.instances.estimee": "Attribution estimated at read time: a project's variant is the one of the template it is pinned to today; the variant actually run is not recorded.",
  "v8d.workflow.instances.nombre": "{{n}} running",
  "v8d.workflow.instances.non_nommes": "and {{n}} projects you cannot read",
  "v8d.workflow.instances.projet": "{{nom}} ({{n}})",
  "v8d.workflow.instances.titre": "Running instances by version",
  "v8d.workflow.instances.variante_courante": "Estimated variant {{empreinte}} — {{modele}}, current configuration (project not pinned)",
  "v8d.workflow.instances.variante_inconnue": "Unknown variant: the template or its version no longer exists",
  "v8d.workflow.instances.variante_version": "Estimated variant {{empreinte}} — {{modele}}, version {{n}}",
  "v8d.workflow.instances.version_ancienne": "Older version: these instances finish on their version.",
  "v8d.workflow.instances.vide": "No running instance.",
  "v8d.workflow.modeles.configuration_seule": "Current configuration only, no published version.",
  "v8d.workflow.modeles.titre": "Templates that use it",
  "v8d.workflow.modeles.version_etape": "version {{n}}, step {{etape}}",
  "v8d.workflow.modeles.version_sans_etape": "version {{n}}, no process step automates it",
  "v8d.workflow.modeles.vide": "No visible template uses this workflow.",
  "v8d.workflow.origine.organisation": "Created by the organisation",
  "v8d.workflow.origine.organisation_court": "organisation",
  "v8d.workflow.origine.plateforme": "Provided by the platform, not editable",
  "v8d.workflow.origine.plateforme_court": "platform",
  "v8d.workflow.taches.droit_a_decider": "Who holds it: legacy roles; atomic right not decided yet.",
  "v8d.workflow.taches.ligne": "{{etape}} — {{modele}}",
  "v8d.workflow.taches.roles": "Roles: {{roles}}",
  "v8d.workflow.taches.titre": "Human tasks and who holds them",
  "v8d.workflow.taches.vide": "No human step waits on this workflow.",
  "v8d.workflow.tout_le_catalogue": "Whole catalogue",
  "v8d.workflow.usages.libelle": "the workflow usages",
  "v8d.workflow.versions.aucun_espace": "Used by no space.",
  "v8d.workflow.versions.brouillon": "Unpublished draft",
  "v8d.workflow.versions.espaces_caches": "Used by {{n}} spaces, not readable by you.",
  "v8d.workflow.versions.espaces_noms": "Used by {{n}} spaces: {{noms}}.",
  "v8d.workflow.versions.espaces_noms_et_caches": "Used by {{n}} spaces: {{noms}} and {{caches}} not readable.",
  "v8d.workflow.versions.libelle": "the workflow versions",
  "v8d.workflow.versions.porteur_courant": "{{modele}} (current configuration)",
  "v8d.workflow.versions.porteur_version": "{{modele}} v{{n}}",
  "v8d.workflow.versions.porteurs": "Carried by: {{porteurs}}",
  "v8d.workflow.versions.publiee": "published on {{date}} by {{nom}}",
  "v8d.workflow.versions.rang": "Variant {{n}}",
  "v8d.workflow.versions.sans_validation": "no validation recorded",
  "v8d.workflow.versions.titre": "Versions",
  "v8d.workflow.versions.validee": "validated by {{nom}}",
  "v8d.workflow.versions.vide": "No version of this workflow."
}
